export default "__VITE_ASSET__f78e4904__"